import Configuration from '@/src/components/Configuration/Configuration';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import Select from 'src/components/Antd/Select/OriginalSelect';
import DroppableTable from 'src/components/DroppableTable/EditDraggableTable';
import { TableSelect } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Search from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableSearch';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const { Option, OptionGroup: OptGroup } = Select;
enum EAutoFillProvider {
  Google = 'Google',
  AuPost = 'AuPost',
}

const DeliveryAddressSettings = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid: salesChannelUuid }: any = useParams();
  const { data, formats, onChange, setHasModified, disableEdit } = props;

  const handleHasModified = () => {
    setHasModified(true);
  };
  // const [test, setTest] = React.useState({
  //   Au: { disableDrag: true, hideDragger: false },
  //   Us: { disableDrag: false, hideDragger: true },
  //   Hk: { disableDrag: true, hideDragger: true },
  // });
  //const [displayData, setDisplayData] = React.useState(data || []);
  const [searchText, setSearchText] = React.useState('');

  const handleOnSearch = (text) => {
    setSearchText(text);
  };

  const handleOnAddressChange = (code, address) => {
    handleHasModified();
    const _data = [...data];
    _data.forEach((i) => {
      const _code = get(i, 'country.code');
      if (_code === code) {
        i.autoFillProvider = address;
      }
    });
    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnFormatChange = (code, formatUuid) => {
    handleHasModified();
    const _data = [...data];
    const format = formats.find((i) => i.uuid === formatUuid);
    _data.forEach((i) => {
      const _code = get(i, 'country.code');
      if (_code === code) {
        i.format = format;
      }
    });
    if (onChange) {
      onChange(_data);
    }
  };

  const currentData = React.useMemo(() => {
    if (!searchText) {
      return data;
    } else {
      return data.filter((i) => {
        const name = get(i, 'country.name').toLowerCase();
        const _s = searchText.toLowerCase();
        return name.indexOf(_s) > -1;
      });
    }
  }, [searchText, data]);

  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.deliveryAddressSetting')}
      subtitle={getI18n(
        'salesChannelCheckout.index.deliveryAddressSettingSub',
      )}>
      <div className={css.container}>
        <div className={css.serach}>
          <Search
            onSearch={handleOnSearch}
            placeholder={getI18n(
              'salesChannelCheckout.index.searchcountryregion',
            )}
          />
        </div>

        <DroppableTable
          className={css.table}
          // scroll={{ y: 520, x: 'max-content' }}
          //availabilityConfig={test}
          hideAllDragHandlers={!!searchText || disableEdit}
          pagination={false}
          rowKey={(record) => {
            return get(record, 'country.code');
          }}
          dataSource={currentData || []}
          columns={col(
            handleOnAddressChange,
            handleOnFormatChange,
            formats,
            disableEdit,
            { getI18n },
          )}
          id='SalesChannelCheckoutDeliveryAddressSettingTable'
          onTableChange={(e) => {
            handleHasModified();
            if (onChange) onChange(e);
          }}
          // rowDeleteFunc={deleteProduct}
        />
        <div className={css.configContainer}>
          <Configuration
            configStart={getI18n(
              'salesChannelCheckout.index.gotoSalesChannelSettings',
            )}
            configLink={getI18n('salesChannelCheckout.index.logistic')}
            linkTo={`/salesChannel/setting/logistics/${salesChannelUuid}`}
            configEnd={getI18n('salesChannelCheckout.index.toaddadestination')}
          />
        </div>
      </div>
    </SectionWrapper>
  );
};
export default DeliveryAddressSettings;
const col = (
  onAutoChange,
  onFormatChange,
  formats,
  disableEdit,
  { getI18n },
) => {
  return [
    {
      title: getI18n('general.countryRegion'),
      key: 'lo',
      default: true,
      childGenerate: (url, record) => {
        const name = get(record, `country.name`);
        return (
          <NoWrapContainer>
            <GlobalTooltip title={name}>{name}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 300,
    },
    {
      title: () => {
        return (
          <div>
            <EditIcon />
            {getI18n('salesChannelCheckout.index.addressAutofill')}
          </div>
        );
      },
      key: 'autofill',
      default: true,
      childGenerate: (url, record) => {
        const autoFillProvider = get(record, `autoFillProvider`);
        const code = get(record, `country.code`);
        const label =
          {
            [EAutoFillProvider.AuPost]: getI18n(
              'salesChannelCheckout.index.aUPost',
            ),
            [EAutoFillProvider.Google]: getI18n(
              'salesChannelCheckout.index.google',
            ),
          }[autoFillProvider] ||
          getI18n('salesChannelCheckout.index.noAutofill');
        return (
          <TableSelect
            label={label}
            value={autoFillProvider}
            disabled={disableEdit}
            onChange={(e) => {
              if (onAutoChange) {
                onAutoChange(code, e);
              }
            }}>
            <Select.Option value={null}>
              {getI18n('salesChannelCheckout.index.noAutofill')}
            </Select.Option>
            <Select.Option value={EAutoFillProvider.AuPost}>
              {getI18n('salesChannelCheckout.index.aUPost')}
            </Select.Option>
            <Select.Option value={EAutoFillProvider.Google}>
              {getI18n('salesChannelCheckout.index.google')}
            </Select.Option>
          </TableSelect>
        );
      },
      width: 300,
    },
    {
      title: () => {
        return (
          <div>
            <EditIcon />
            {getI18n('salesChannelCheckout.index.addressLocalisation')}
          </div>
        );
      },
      key: 'Localisation',
      default: true,
      childGenerate: (url, record) => {
        const code = get(record, `country.code`);
        const { defaultOptions, customOptions } = generateOptions(
          code,
          formats,
        );

        const label = get(record, 'format.name', '-');
        const value = get(record, 'format.uuid');
        // const autoFillProvider = get(record, `autoFillProvider`);

        return (
          <TableSelect
            itemProps={{
              getPopupContainer: () => document.body,
            }}
            label={label}
            value={value}
            disabled={disableEdit}
            onChange={(e) => {
              console.log(e);
              if (onAutoChange) {
                onFormatChange(code, e);
              }
            }}>
            {defaultOptions.length > 0 && (
              <OptGroup
                label={getI18n('salesChannelCheckout.index.defaultFormats')}>
                {defaultOptions.map((i) => {
                  const uuid = get(i, 'uuid');
                  const name = get(i, 'name');
                  return (
                    <Option key={uuid} value={uuid}>
                      {name}
                    </Option>
                  );
                })}
              </OptGroup>
            )}
            {customOptions.length > 0 && (
              <OptGroup
                label={getI18n('salesChannelCheckout.index.customisedFormats')}>
                {customOptions.map((i) => {
                  const uuid = get(i, 'uuid');
                  const name = get(i, 'name');
                  return (
                    <Option key={uuid} value={uuid}>
                      {name}
                    </Option>
                  );
                })}
              </OptGroup>
            )}
          </TableSelect>
        );
      },
      minWidth: 350,
    },
  ];
};
const generateOptions = (code, options) => {
  const first = options.filter((i) => i.countryCode === code);
  const _default = options.filter((i) => i.defaultFormat);
  const ilFormats = options.filter(
    (i) => !i.countryCode && !i.defaultFormat && !i.customized,
  );
  const topPart = [...first, ..._default, ...ilFormats];

  const custom = options.filter((i) => i.customized);
  return {
    defaultOptions: topPart,
    customOptions: custom,
  };
};
